module.exports = __webpack_public_path__ + "img/header-title.08c8f6dd.webp";